<template>
  <footer class="new-footer">
    <div class="container">
      <div class="row">
        <div class="col-md-3 text-center text-sm-left">
          <img src="~assets/images/footer_logo.png" class="img-responsive center-sm-block">
        </div>
        <div class="col-md-2 text-center text-sm-left">
          <h4>Our Products</h4>
          <ul class="list-unstyled">
            <li><router-link to="/patient">Patient</router-link></li>
            <li><router-link to="/practice">Practice</router-link></li>
            <li><router-link to="/academic">Academic</router-link></li>
          </ul>
        </div>
        <div class="col-md-2 text-center text-sm-left">
          <h4>Useful Links</h4>
          <ul class="list-unstyled">
            <li><a @click="openModal('privacy')" id="openPrivacyModal">Privacy</a></li>
            <li><a @click="openModal('terms')" id="openTermsModal">Terms and Conditions</a></li>
            <li><a @click="openModal('popi')" id="openPopiModal">Protection of Personal Information (POPI)</a></li>
          </ul>
        </div>
        <div class="col-md-2 text-center text-sm-left">
          <h4>Johannesburg Office</h4>
          <p>Building 12<br>
            Woodmead Estate<br>
            1 Woodmead Drive<br>
            Woodmead</p>
          <h4>Pretoria Office</h4>
          <p>46 Ingersol Road<br>
            Lynnwood Glen<br>
            Pretoria</p>
        </div>
        <div class="col-md-3 text-center text-sm-left">
          <h4>Contact Us</h4>
          <ul class="list-unstyled ">
            <li class="m-b"><a href="mailto:contact@logbox.co.za" class="h4 m-t-0"><i class="fa fa-envelope"></i> contact@logbox.co.za</a></li>
            <li><a href="tel:+27822627238" class="h4 m-b-0"><i class="fa fa-phone"></i> 082 262 7238</a></li>
          </ul>
        </div>
      </div>
    </div>

    <div class="group-elephant">
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-right">
            <a href="http://www.groupelephant.com" target="_blank"><img src="~assets/images/Group_Elephant_Logo.svg"> part of the groupelephant.com family</a>
          </div>
        </div>
      </div>
    </div>

    <popi-modal :open="popiModalOpen" @close="closeModal('popi')"></popi-modal>
    <privacy-modal :open="privacyModalOpen" @close="closeModal('privacy')"></privacy-modal>

    <ud-terms-modal :open="udTermsModalOpen" @close="closeModal('udTerms')"></ud-terms-modal>
    <academic-terms-modal :open="academicTermsModalOpen" @close="closeModal('academicTerms')"></academic-terms-modal>
  </footer>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'footer-bar',
    components: {
      PopiModal: () => import('components/common/modals/PopiModal'),
      PrivacyModal: () => import('components/common/modals/PrivacyModal'),
      UdTermsModal: () => import('components/common/modals/UdTermsModal'),
      AcademicTermsModal: () => import('components/common/modals/AcademicTermsModal'),
    },
    data: () => ({
      popiModalOpen: false,
      privacyModalOpen: false,
      udTermsModalOpen: false,
      academicTermsModalOpen: false,
    }),
    computed: mapState([
      'context',
    ]),
    methods: {
      openModal(type) {
        switch (type) {
          case 'popi':
            this.popiModalOpen = true;
            break;
          case 'privacy':
            this.privacyModalOpen = true;
            break;
          case 'terms':
            if (this.context === 'academic') {
              this.academicTermsModalOpen = true;
            } else {
              this.udTermsModalOpen = true;
            }
            break;
          case 'academicTerms':
            this.academicTermsModalOpen = true;
            break;
          default:
            break;
        }
      },
      closeModal(type) {
        switch (type) {
          case 'popi':
            this.popiModalOpen = false;
            break;
          case 'privacy':
            this.privacyModalOpen = false;
            break;
          case 'udTerms':
            this.udTermsModalOpen = false;
            break;
          case 'academicTerms':
            this.academicTermsModalOpen = false;
            break;
          default:
            break;
        }
      },
    },
  };

</script>



// WEBPACK FOOTER //
// FooterBar.vue?2c3b1ba6